import { Input } from "./ui/input";
import { PRESETS } from "../lib/format";

export const DateFilter = ({ preset, setPreset, from, setFrom, to, setTo, presets = PRESETS }) => (
  <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto min-w-0">
    <div className="flex gap-1 overflow-x-auto no-scrollbar rounded-xl border p-1 bg-card min-w-0 flex-1 basis-full sm:basis-auto">
      {presets.map(([k, l]) => (
        <button key={k} onClick={() => setPreset(k)} data-testid={`date-preset-${k}`}
          className={`px-3 py-1.5 text-sm rounded-lg whitespace-nowrap transition-colors ${preset === k ? "bg-primary text-primary-foreground" : "hover:bg-accent"}`}>
          {l}
        </button>
      ))}
    </div>
    {preset === "custom" && (
      <div className="flex items-center gap-2">
        <Input type="date" className="w-auto" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="date-from-input" />
        <span className="text-muted-foreground">-</span>
        <Input type="date" className="w-auto" value={to} onChange={(e) => setTo(e.target.value)} data-testid="date-to-input" />
      </div>
    )}
  </div>
);
